import React from 'react'

import config from '../config.js'

class Participant extends React.Component {
  render() {
    return (
      <span key={this.props.participant.accountId} className="participant">
        <img
          src={
            this.props.participant.avatarUrl == null
              ? config.baseUrl + '/assets/img/generic-avatar-small.png'
              : this.props.participant.avatarUrl + '=s48-c'
          }
          alt={this.props.participant.displayName + ' Avatar'}
        />
        <br />
        <span className="participant__name">
          {this.props.participant.accountId === this.props.aid
            ? 'You'
            : this.props.participant.displayName}
        </span>
      </span>
    )
  }
}

export default Participant



// WEBPACK FOOTER //
// ./src/Components/Participant.js